import { render, staticRenderFns } from "./b2b-dialog-select-company.vue?vue&type=template&id=38267832"
import script from "./b2b-dialog-select-company.vue?vue&type=script&lang=js"
export * from "./b2b-dialog-select-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports